<template>
    <div class="container">
        <div class="tabs">
            <div class="item" :class="{ 'active' : current == 0 } " @click="current = 0">规格汇总表</div>
            <div class="item" :class="{ 'active' : current == 1 } " @click="current = 1">品牌汇总表</div>
            <div class="item" :class="{ 'active' : current == 2 } " @click="current = 2">品名汇总表</div>
            <div class="item" :class="{ 'active' : current == 3 } " @click="current = 3">自定义汇总表</div>
        </div>
        <div class="tab_content">
            <Specification ref="warehouse_repert_content_0" v-show="current == 0"></Specification>
            <Brand ref="warehouse_repert_content_1" v-show="current == 1"></Brand>
            <Breed ref="warehouse_repert_content_2" v-show="current == 2"></Breed>
            <Customize ref="warehouse_repert_content_3" v-show="current == 3"></Customize>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2; overflow: auto;
        .tabs{
            display: flex; align-items: center; margin-bottom: 23px;
            .item {
                font-size:16px; font-weight:bold; color: #333333; cursor: pointer; border-bottom: 2px solid transparent; padding-bottom: 5px;
                &.active{ border-bottom: 2px solid #B21111;}
            }
            .item + .item{ margin-left: 30px; }
        }
        .tab_content{ flex: 1; display: flex; flex-direction: column; height: 100%; overflow: hidden; }
    }
</style>
<script>
import Customize from '../../../components/warehouse/report/customize.vue'
import Brand from '../../../components/warehouse/report/brand.vue'
import Breed from '../../../components/warehouse/report/breed.vue'
import Specification from '../../../components/warehouse/report/specification.vue'
    export default {
        components:{
            Specification,
            Brand,
            Breed,
            Customize,
        },
        data(){
            return{
                current : 0,
            }
        },
        created() {

        },
        mounted() {
            this.$refs[`warehouse_repert_content_0`].getList();
        },
        methods:{

        },
        watch:{
            current(val){
                this.$refs[`warehouse_repert_content_${val}`].getList();
            }
        }
    }
</script>
